import { RECAPTCHA_PUBLIC_KEY } from "../configs/recaptchaConfig";

const script = document.createElement("script");
script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_PUBLIC_KEY}`;
script.async = true;
script.defer = true;
document.head.appendChild(script);
